import React from "react";
import { useTranslation } from "react-i18next";
import { NoData } from "@components/common/NoData/NoData";
import { instituteCourseFieldConfig } from "../institute.config";
import type { InstituteCourseDetails } from "../types/types";
import InstituteDetailsFieldGrid from "./InstituteDetailsFieldGrid";

interface CoursesStepProps {
	data?: InstituteCourseDetails[];
}

const CoursesStep: React.FC<CoursesStepProps> = ({ data }) => {
	const { t } = useTranslation();
	const courses = data ?? [];

	if (courses.length === 0) {
		return (
			<div className="space-y-4 p-2">
				<div className="text-xl font-semibold text-gray-800">{t("components.instituteDetails.courses.title")}</div>
				<div className="rounded-lg border border-dashed border-gray-300 bg-gray-50/80 px-6 py-10 shadow-inner">
					<NoData msg={t("components.instituteDetails.courses.noData")} />
				</div>
			</div>
		);
	}

	return (
		<div className="space-y-6 p-2">
			<div className="text-xl font-semibold text-gray-800">{t("components.instituteDetails.courses.title")}</div>
			{courses.map((course, index) => {
				const fields = instituteCourseFieldConfig.map(field => ({
					...field,
					value: course[field.name as keyof InstituteCourseDetails]?.toString() || "—",
				}));

				return (
					<section
						key={course.uuid}
						className="rounded-lg border border-gray-200 bg-white shadow-sm overflow-hidden">
						<div className="border-l-4 border-primary bg-primary/5 px-4 py-3">
							<h3 className="text-base font-semibold text-gray-900">
								{t("components.instituteDetails.courses.courseTitle", { number: index + 1 })}
								{course.name !== "—" ? (
									<span className="ml-2 font-medium text-gray-600">— {course.name}</span>
								) : null}
							</h3>
						</div>
						<div className="p-4">
							<InstituteDetailsFieldGrid fields={fields} columnsClassName="grid-cols-1 md:grid-cols-2 lg:grid-cols-3" />
						</div>
					</section>
				);
			})}
		</div>
	);
};

export default CoursesStep;
